import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter, ContentChildren, QueryList, TemplateRef, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { AppTemplateDirective } from 'app/directive';
import { HTTPService, HelperService } from 'app/services';

@Component({
  selector: 'app-switch-card',
  templateUrl: './switch-card.component.html',
  styleUrls: ['./switch-card.component.scss'],
})
export class SwitchCardComponent implements OnInit, AfterViewInit {
  @Input() id: string = '';
  @Input() heading: string = '';
  @Input() content: string = '';
  @Input() switch: boolean = false;
  @Input() isAccordin: boolean = false;
  @Input() isAccordinOpen: boolean = true;
  @Input() showAccordinIcon: boolean = false;
  @Input() hasCustomTemplate: boolean = false;
  @Input() active: any;
  @Input() styleLeftCol: string = 'ui-g-10';
  @Input() styleRightCol: string = 'ui-g-2';
  @Input() fontSize: number = 14;
  @Input() defaultSchedulePickUpState: boolean = false
  @Input() isSchedulePickUp: boolean = false
  @Input() isFetching: boolean = false
  @Input() isDataLoading: boolean = false

  @Output() appChange = new EventEmitter<any>();
  @Output() appUpdateSettings = new EventEmitter<any>();

  @ViewChild('switchCardContainer')
  switchCardContainer: ElementRef;

  @ContentChildren(AppTemplateDirective) templates: QueryList<any>;

  overlayTemplate: TemplateRef<any>;
  showSaved: boolean = false;

  constructor(private cdr: ChangeDetectorRef, private httpService: HTTPService, private helperService: HelperService) { }

  ngOnInit() { }

  ngAfterViewInit() {
    this.getCustomTemplate();
    this.cdr.detectChanges();
  }

  onModelChange(active) {
    this.showSaved = false;
    this.appChange.emit(active);
  }

  toggleAccordin() {
    if (this.isAccordin) {
      this.isAccordinOpen = !this.isAccordinOpen;
    }
  }

  /** get all the custom templates */
  getCustomTemplate() {
    this.templates.forEach((item) => {
      switch (item.getType()) {
        case 'item':
          this.overlayTemplate = item.template;
          break;
      }
    });
  }

  updateScheduleSettings() {
    const payload = {isSchedulePickupOn: this.isSchedulePickUp};
    this.httpService.updateAppSettings(payload).then(
      (res) => {
        this.showSaved = true;
        this.appUpdateSettings.emit(payload.isSchedulePickupOn)
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }
}
